import { Injectable } from "@angular/core";
import { Career } from "../interface/career";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  currentLetter: string = "U";
  currentStep: any = 1;
  isCompletedWelcome: boolean;
  isCompletedStep1: boolean;
  isCompletedStep2: boolean;
  isCompletedStep3: boolean;
  career: Career;
  constructor() {
    this.isCompletedWelcome = false;
    this.isCompletedStep1 = false;
    this.isCompletedStep2 = false;
    this.isCompletedStep3 = false;
  }
}
